import { useUser } from '@folklore/auth';

import { useAttributionKey } from '../contexts/AuthContext';

interface AttributionQuery {
    _att: string;
    utm_campaign?: string;
}

export function useAttributionQuery(): AttributionQuery | null {
    const { author: userAuthor = null } = useUser() || {};
    const { slug: authorSlug = null } = userAuthor || {};
    const attributionKey = useAttributionKey();
    return attributionKey !== null
        ? {
              _att: attributionKey,
              ...(authorSlug !== null ? { utm_campaign: authorSlug } : null),
          }
        : null;
}
